import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldLength extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'length');
  }
}
